module.exports = __webpack_public_path__ + "img/faq-bg.387989a8.png";